// Omnix/client/ui/ContactForm.js
import { ComponentBase } from "../core/ComponentBase.js";

export class ContactForm extends ComponentBase {
    static styles = `
        .contact-form-modal .modal-body { max-height: 70vh; overflow-y: auto; }
        .channel-row { display: flex; gap: 0.5rem; align-items: center; margin-bottom: 0.5rem; }
        .channel-row .form-select, .channel-row .form-control { flex: 1; }
        .channel-row .btn-danger { flex-shrink: 0; }
    `;

    constructor(config) {
        super(config);
        this.mode = 'create';
        this.contactData = null;
        this.tagInput = null;
        this.applyStyles();
    }

    show(mode, contactData = null) {
        this.mode = mode;
        this.contactData = contactData;
        this.render();
        this.modalInstance.show();
    }

    async render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'modal fade contact-form-modal';
            this.container.id = `${this.config.instanceId}-modal`;
            this.container.setAttribute('tabindex', '-1');
            this.container.innerHTML = `
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title"></h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div class="modal-body">
                            <form id="${this.config.instanceId}-form">
                                <h6 class="mb-3">Basic Information</h6>
                                <div class="row">
                                    <div class="col-md-6 mb-3"><label class="form-label">First Name</label><input type="text" name="firstName" class="form-control"></div>
                                    <div class="col-md-6 mb-3"><label class="form-label">Last Name</label><input type="text" name="lastName" class="form-control"></div>
                                    <div class="col-md-6 mb-3"><label class="form-label">Email</label><input type="email" name="email" class="form-control"></div>
                                    <div class="col-md-6 mb-3"><label class="form-label">Company</label><input type="text" name="company" class="form-control"></div>
                                </div>
                                <hr>
                                <h6 class="mb-3">Channels</h6>
                                <div id="channels-container"></div>
                                <button type="button" class="btn btn-sm btn-outline-secondary" id="add-channel-btn"><i class="bi bi-plus"></i> Add Channel</button>
                                <hr>
                                <h6 class="mb-3">Settings</h6>
                                <div class="mb-3">
                                    <label class="form-label">Visibility</label>
                                    <select name="visibility" class="form-select">
                                        <option value="private">Private (Only visible to me)</option>
                                        <option value="public">Public (Visible to all users)</option>
                                    </select>
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Tags</label>
                                    <div id="contact-tags-container"></div>
                                </div>
                            </form>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-primary" id="save-contact-btn">Save Contact</button>
                        </div>
                    </div>
                </div>
            `;
            this.modalInstance = new bootstrap.Modal(this.container);
            this.formElement = this.container.querySelector('form');
            this.channelsContainer = this.container.querySelector('#channels-container');
            this.tagsContainer = this.container.querySelector('#contact-tags-container');

            this.container.querySelector('#add-channel-btn').addEventListener('click', () => this._addChannelRow());
            this.container.querySelector('#save-contact-btn').addEventListener('click', () => this.handleSave());
        }

        if (!this.tagInput) {
            this.tagInput = await this.createManagedComponent('TagInput', this.tagsContainer, {
                instanceId: `${this.config.instanceId}-tags`,
                creatable: true,
                optionsSourceRpc: {
                    method: 'OmniContactsRpc.getContactTags'
                },
                placeholder: 'Add tags...'
            });
        }

        this.container.querySelector('.modal-title').textContent = this.mode === 'create' ? 'Create New Contact' : 'Edit Contact';
        this.formElement.reset();
        this.channelsContainer.innerHTML = '';

        if (this.mode === 'edit' && this.contactData) {
            Object.keys(this.contactData).forEach(key => {
                const input = this.formElement.querySelector(`[name="${key}"]`);
                if (input) input.value = this.contactData[key];
            });
            (this.contactData.channels || []).forEach(channel => this._addChannelRow(channel));
            if (this.tagInput) {
                this.tagInput.setValue(this.contactData.tags || []);
            }
        } else {
            this._addChannelRow();
            if (this.tagInput) {
                this.tagInput.setValue([]);
            }
        }

        return this.container;
    }

    getUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}


    _addChannelRow(channel = {}) {
        const channelId = channel.channelId || this.getUUID();
        const row = document.createElement('div');
        row.className = 'channel-row';
        row.dataset.channelId = channelId;

        // Type Selector
        const typeSelect = document.createElement('select');
        typeSelect.className = 'form-select form-select-sm';
        typeSelect.name = 'channelType';

        // --- START FIX: Add new channel types to the options array ---
        const channelTypes = ['email', 'sms', 'whatsapp', 'voice', 'web_chat', 'facebook_messenger', 'instagram', 'telegram'];
        // --- END FIX ---

        typeSelect.innerHTML = channelTypes.map(t => `<option value="${t}" ${channel.type === t ? 'selected' : ''}>${this.t(t.replace(/_/g, ' '))}</option>`).join('');

        // Value Input
        const valueInput = document.createElement('input');
        valueInput.type = 'text';
        valueInput.className = 'form-control form-control-sm';
        valueInput.name = 'channelValue';
        valueInput.placeholder = 'Value (e.g., email or phone)';
        valueInput.value = channel.value || '';

        // Label Input
        const labelInput = document.createElement('input');
        labelInput.type = 'text';
        labelInput.className = 'form-control form-control-sm';
        labelInput.name = 'channelLabel';
        labelInput.placeholder = 'Label (e.g., Work)';
        labelInput.value = channel.label || '';

        // Preferred Radio
        const preferredDiv = document.createElement('div');
        preferredDiv.className = 'form-check';
        const preferredRadio = document.createElement('input');
        preferredRadio.className = 'form-check-input';
        preferredRadio.type = 'radio';
        preferredRadio.name = 'isPreferredChannel';
        preferredRadio.value = channelId;
        preferredRadio.checked = channel.isPreferred;
        const preferredLabel = document.createElement('label');
        preferredLabel.className = 'form-check-label small';
        preferredLabel.textContent = 'Pref.';
        preferredDiv.appendChild(preferredRadio);
        preferredDiv.appendChild(preferredLabel);

        // Remove Button
        const removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.className = 'btn btn-sm btn-outline-danger';
        removeButton.innerHTML = '<i class="bi bi-trash"></i>';
        removeButton.addEventListener('click', () => row.remove());

        row.appendChild(typeSelect);
        row.appendChild(valueInput);
        row.appendChild(labelInput);
        row.appendChild(preferredDiv);
        row.appendChild(removeButton);

        this.channelsContainer.appendChild(row);
    }


    _getChannelsData() {
        const rows = this.channelsContainer.querySelectorAll('.channel-row');
        const preferredChannelId = this.formElement.querySelector('input[name="isPreferredChannel"]:checked')?.value;
        return Array.from(rows).map(row => ({
            channelId: row.dataset.channelId,
            type: row.querySelector('[name="channelType"]').value,
            value: row.querySelector('[name="channelValue"]').value.trim(),
            label: row.querySelector('[name="channelLabel"]').value.trim(),
            isPreferred: row.dataset.channelId === preferredChannelId
        })).filter(ch => ch.value);
    }

    async handleSave() {
        const formData = new FormData(this.formElement);
        const data = Object.fromEntries(formData.entries());
        delete data.channelType;
        delete data.channelValue;
        delete data.channelLabel;
        delete data.isPreferredChannel;
        data.channels = this._getChannelsData();
        data.tags = this.tagInput ? this.tagInput.getValue() : [];

        try {
            if (this.mode === 'create') {
                await this.appClient.rpcClient.call('OmniContactsRpc.create', data);
                this.appClient.notifier.success("Contact created successfully.");
            } else {
                data._id = this.contactData._id;
                await this.appClient.rpcClient.call('OmniContactsRpc.update', data);
                this.appClient.notifier.success("Contact updated successfully.");
            }
            this.emit('contactSaved');
            this.modalInstance.hide();
        } catch (error) {
            this.log.error(`Failed to save contact:`, error);
            this.appClient.notifier.error(`Error: ${error.message}`);
        }
    }
}